"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkRXBCYLK6_js = require('./chunk-RXBCYLK6.js');
var React = require('react');
var core = require('@atom-web/core');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var StyledChevronDown = core.styled(chunkRXBCYLK6_js.ChevronDown_default);
var ChevronDown = ({ fill, ...props }) => {
  return /* @__PURE__ */ React__namespace.createElement(StyledChevronDown, {
    css: {
      fill
    },
    ...props
  });
};
var ChevronDown_default2 = ChevronDown;

exports.ChevronDown_default = ChevronDown_default2;
